export class UserCredentials {
    constructor(public login: string, public password: string) {
    }
}